// @flow

import React from 'react';
import { Card, Icon } from '../';
import { statusColor } from '../../../utils';
import AlertIconWrapper from './AlertIconWrapper';

type Props = {
  status: String,
  language: Object,
};

export default function AlertIcon(props: Props) {
  const { status, language } = props;

  const iconName = () => {
    if (status === 'success') {
      return 'checked';
    } else if (status === 'failure') {
      return 'sad';
    } else if (status === 'info') {
      return 'info';
    } else {
      return 'warning';
    }
  };

  return (
    <AlertIconWrapper
      type="backgroundGray"
      width="70px"
      height="70px"
      language={language}
      radius="50%"
      hasShadow={false}
    >
      <Card
        type="backgroundGray"
        radius="50%"
        className="d-flex align-items-center justify-content-center"
        hasShadow={false}
      >
        <Card
          type={statusColor(status)}
          width="55px"
          height="55px"
          radius="50%"
          className="d-flex align-items-center justify-content-center"
          hasShadow={false}
        >
          <Icon name={iconName()} size={30} color="white" />
        </Card>
      </Card>
    </AlertIconWrapper>
  );
}
